import { useEffect } from 'react';
import { CivicSignEventTypeRequest, remoteSignWindowEventEmitterImplementation } from '../utils/remoteSign';
import logger from '../logger';
const logDebug = (message, obj = null) => logger.debug(`[useCivicPassEventListener] ${message}`, obj);
const logError = (message, obj = null) => logger.error(`[useCivicPassEventListener] ${message}`, obj);
const useCivicPassEventListener = ({ wallet, chainImplementation, remoteSign, }) => {
    const dispatchEvent = async (response) => {
        if (!wallet)
            return;
        const remoteSigner = remoteSign !== null && remoteSign !== void 0 ? remoteSign : remoteSignWindowEventEmitterImplementation();
        const events = {
            [CivicSignEventTypeRequest.REQUEST_PUBLIC_KEY]: () => new Promise((resolve) => {
                remoteSigner === null || remoteSigner === void 0 ? void 0 : remoteSigner.sendPublicKey(wallet.publicKey);
                resolve();
            }),
            [CivicSignEventTypeRequest.REQUEST_DID]: () => new Promise((resolve) => {
                remoteSigner === null || remoteSigner === void 0 ? void 0 : remoteSigner.sendDid(`did:sol:${wallet.publicKey}`);
                resolve();
            }),
            [CivicSignEventTypeRequest.REQUEST_SIGNED_PROOF]: async () => {
                try {
                    const proof = await chainImplementation.proveWalletOwnership();
                    remoteSigner === null || remoteSigner === void 0 ? void 0 : remoteSigner.sendSignedProof(proof);
                }
                catch (err) {
                    logError('Error signing proof', err);
                }
            },
        };
        const event = events[response];
        if (event) {
            await event();
            logDebug('Successfully emitted compliance event', response);
        }
    };
    /**
     * Listen for post messages from the compliance iframe and dispatch events
     * based on the event type
     */
    useEffect(() => {
        const handler = async (response) => {
            await dispatchEvent(response.data);
        };
        window.addEventListener('message', handler);
        return () => {
            logDebug('Removing event listener for compliance');
            return window.removeEventListener('message', handler);
        };
    }, []);
    return { dispatchEvent };
};
export default useCivicPassEventListener;
